/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type RouteTitle_route$ref = any;
export type routeRoutes_RouteTitle_QueryVariables = {|
  routeId: string
|};
export type routeRoutes_RouteTitle_QueryResponse = {|
  +route: ?{|
    +$fragmentRefs: RouteTitle_route$ref
  |}
|};
export type routeRoutes_RouteTitle_Query = {|
  variables: routeRoutes_RouteTitle_QueryVariables,
  response: routeRoutes_RouteTitle_QueryResponse,
|};
*/


/*
query routeRoutes_RouteTitle_Query(
  $routeId: String!
) {
  route(id: $routeId) {
    ...RouteTitle_route
    id
  }
}

fragment RouteTitle_route on Route {
  gtfsId
  shortName
  color
  mode
  type
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_RouteTitle_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RouteTitle_route"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routeRoutes_RouteTitle_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gtfsId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61ce808d0e7506af1bb6281863a80a43",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_RouteTitle_Query",
    "operationKind": "query",
    "text": "query routeRoutes_RouteTitle_Query(\n  $routeId: String!\n) {\n  route(id: $routeId) {\n    ...RouteTitle_route\n    id\n  }\n}\n\nfragment RouteTitle_route on Route {\n  gtfsId\n  shortName\n  color\n  mode\n  type\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '01f0a014991f73636172b5051373ec99';

module.exports = node;
